const Sizes = {
    size11x17: 2,
    size22x34: 5,
    size36x60: 8,
};

export default Sizes;
